import { Box, Card, Stack, Typography } from '@mui/material'
import { CalendarToday, Chair, History, Apps } from '@mui/icons-material'
import { formatDate, formatTime } from '../../utils/date'
import React from 'react'
import PropTypes from 'prop-types'

const seatShape = PropTypes.shape({
  seat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  rang: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  selected_at: PropTypes.string
})

export function SeatInfoCard({ seat, isSmallScreen, onHistoryClick }) {
  return (
    <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, mb: 2, p: 2 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 1.5,
          pb: 1,
          borderBottom: '1px solid',
          borderColor: 'divider'
        }}
      >
        <Typography variant='subtitle1' fontWeight='bold' color='primary'>
          Informations du siège
        </Typography>
        {onHistoryClick && (
          <Box
            component='span'
            sx={{
              cursor: 'pointer',
              color: 'text.secondary',
              '&:hover': { color: 'primary.main' }
            }}
            onClick={onHistoryClick}
            title='Historique des modifications'
          >
            <History fontSize='small' />
          </Box>
        )}
      </Box>
      <InfoRow icon={Apps} label='Rang' value={seat.rang} />
      <InfoRow icon={Chair} label='Siège' value={seat.seat} />
      {seat.selected_at && (
        <InfoRow
          icon={CalendarToday}
          label='Réservé le:'
          value={`${formatDate(seat.selected_at, isSmallScreen)} à ${formatTime(seat.selected_at)}`}
        />
      )}
    </Card>
  )
}

function InfoRow({ icon: Icon, label, value }) {
  return (
    <Stack direction='row' alignItems='center' spacing={1.5}>
      <Icon sx={{ color: 'text.secondary', fontSize: 22 }} />
      <Typography variant='body2' color='text.secondary' sx={{ width: 100, flexShrink: 0 }}>
        {label}
      </Typography>
      <Typography variant='body1' fontWeight={600}>
        {value}
      </Typography>
    </Stack>
  )
}

SeatInfoCard.propTypes = {
  seat: seatShape.isRequired,
  isSmallScreen: PropTypes.bool.isRequired,
  onHistoryClick: PropTypes.func
}

InfoRow.propTypes = {
  icon: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  mono: PropTypes.bool
}
